// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__merriweatherBold_712ede', '__merriweatherBold_Fallback_712ede', s, e, r, i, f","fontStyle":"normal"},"className":"__className_712ede"};